import { render, staticRenderFns } from "./viewSub.vue?vue&type=template&id=8e20cbda&scoped=true"
import script from "./viewSub.vue?vue&type=script&lang=js"
export * from "./viewSub.vue?vue&type=script&lang=js"
import style0 from "./viewSub.vue?vue&type=style&index=0&id=8e20cbda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e20cbda",
  null
  
)

export default component.exports